import {Component, EventEmitter, Input, Output} from '@angular/core';
import { CommonModule } from '@angular/common';
import {OtpDeliveryMethod, LoginStep} from '../login.model';
import {NzFormModule} from 'ng-zorro-antd/form';
import {
  Level2OtpGeneratorChoiceCardComponent
} from './level2-otp-generator-choice-card/level2-otp-generator-choice-card.component';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-level2-otp-generator-choice',
  standalone: true,
  imports: [CommonModule, NzFormModule, Level2OtpGeneratorChoiceCardComponent, NzButtonModule],
  templateUrl: './level2-otp-generator-choice.component.html',
  styleUrls: ['./level2-otp-generator-choice.component.sass']
})
export class Level2OtpGeneratorChoiceComponent {
  @Input({required: true}) level2OtpGenerators: OtpDeliveryMethod[];
  @Input({required: true}) onClickCard: (level2RecognitionType: OtpDeliveryMethod) => void;
  @Output() onBack = new EventEmitter<LoginStep>();

  readonly otpDeliveryMethod = OtpDeliveryMethod;
  readonly showAuthenticationWithApp = environment.showAuthenticationWithApp;

  onBackClick($event: MouseEvent): void {
    this.onBack.emit(LoginStep.UsernameAndPassword);
  }
}
